export class StringUtil {
  static replaceKeyword(name: string, value: (string | number | undefined) | (() => string), keywordToReplace: string): string {
    if (value === undefined) return name;
    const start = name.indexOf("{" + keywordToReplace);
    if (start !== -1) {
      const stop = name.indexOf("}", start + 1);
      if (stop !== -1) {
        let subString = name.substring(start + 1, stop);
        const val = typeof value === "function" ? value() : "" + value;
        if (val !== undefined) {
          subString = subString.replace(keywordToReplace, val);
          name = name.substr(0, start) + subString + name.substr(stop + 1);
        }
      }
    }
    return name;
  }

  static replaceKeywords(name: string, options: Record<string, string | number | undefined | (() => string)>): string {
    const keys = Object.keys(options);
    for (const k of keys) {
      const val = options[k];
      name = this.replaceKeyword(name, val, k);
    }
    return name;
  }

  static replaceAll(str: string, search: string, replace: string): string {
    return str.split(search).join(replace);
  }


  // public static applyParams(text: string, params?: StringParameters): string {
  //   if (params !== undefined) {
  //     if (typeof params === "string" || typeof params === "number")
  //       text = StringUtil.replaceAll(text, "${0}", "" + params);
  //     else if (Array.isArray(params)) {
  //       for (let i = 0; i < params.length; i++) {
  //         text = StringUtil.replaceAll(text, "{" + i + "}", "" + params[i]);
  //       }
  //     } else {
  //       const keys = Object.keys(params);
  //       for (const k of keys) {
  //         text = StringUtil.replaceAll(text, "{" + k + "}", "" + params[k]);
  //       }
  //     }
  //   }
  //   return text;
  // }

  static pad(n: string, width: number, z?: string): string {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}
